import { ASSETS, waLink, WA_MESSAGES } from "@/lib/site";
import { MessageCircle } from "lucide-react";

// Friendly mascot help band with WhatsApp CTA (used on home & help pages).
export const MascotHelpSection = ({
  title = "Não sabe por onde começar?",
  text = "A Miríade te ajuda a encontrar o melhor caminho para sua próxima viagem.",
  waMessage = WA_MESSAGES.default,
}) => (
  <section data-testid="mascot-help-section" className="px-4 py-16 sm:px-6 lg:px-8">
    <div className="relative mx-auto flex max-w-5xl flex-col items-center gap-8 overflow-hidden rounded-3xl border border-brand-light bg-brand-light/70 px-6 py-10 sm:flex-row sm:px-12 sm:py-12">
      <div className="absolute -right-10 top-0 h-40 w-40 rounded-full bg-brand-lilac/30 blur-2xl" />
      <img
        src={ASSETS.mascot}
        alt="Mascote da Miríade Turismo"
        className="relative h-40 w-40 shrink-0 object-contain drop-shadow-xl animate-float sm:h-48 sm:w-48"
      />
      <div className="relative text-center sm:text-left">
        <h2 className="font-heading text-2xl font-bold tracking-tight text-ink sm:text-3xl">{title}</h2>
        <p className="mt-3 max-w-md text-base leading-relaxed text-ink-soft">{text}</p>
        <a
          href={waLink(waMessage)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mascot-whatsapp-btn"
          className="mt-6 inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] px-7 py-3.5 text-sm font-semibold text-white transition-all hover:scale-[1.03] hover:bg-[#1ebe5d]"
        >
          <MessageCircle size={18} /> Falar com a Miríade
        </a>
      </div>
    </div>
  </section>
);
